<template>
  <b-navbar class="header d-print-none">
    <b-nav>
      <div style="position: fixed !important">
        <header class="logo sidenav-logo">
          <b-dropdown id="dropdown-left" variant="link" size="sm" no-caret style="max-height: 50px">
            <div slot="button-content" class="head-unhide text-left">
              <span class="text-white hoth-app-header">
                <i
                  class="fa fa-th-large float-right"
                  style="
                    margin-top: 10px;
                    color: white;
                    font-size: 1.25rem !important;
                    padding: 0px 4px;
                    position: relative;
                    top: 2px;
                    left: 6px;
                  "
                ></i>
              </span>
            </div>
            <div
              slot="button-content"
              class="head-hide text-left"
              size="xs"
              style="
                font-size: 1.25rem !important;
                padding: 0px 4px;
                position: relative;
                top: 7px;
              "
            >
              <span class="text-white hoth-app-header ml-2">
                {{ app_display_name }}
                <i
                  class="la la-angle-down la-lg font-weight-bold float-right"
                  style="margin-top: 10px; font-size: 10px"
                ></i>
              </span>
            </div>
            <b-row style="margin-left: 1px; margin-right: 1px">
              <b-col
                lg="4"
                xl="4"
                md="4"
                sm="4"
                class="px-1 py-2"
                v-for="(app_url, index) in app_urls"
                :key="index"
              >
                <b-dropdown-item
                  v-bind:href="app_url.app_url"
                  class="text-center p-2 app-hover"
                  target="_blank"
                >
                  <img
                    class="img-lg mar-ver"
                    style="
                      border-radius: 10px;
                      width: 70px;
                      height: 70px;
                      outline: none;
                      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.01),
                        0 1px 3px rgba(0, 0, 0, 0.05) !important;
                      border: 0 !important;
                      padding: 5px !important;
                    "
                    :src="getImgUrl(app_url.app_image)"
                    v-bind:alt="app_url.app_image"
                  />
                  <p class="font-weight-bold text-uppercase mb-0 mt-3" style="font-size: 9px">
                    {{ app_url.app_name }}
                  </p>
                </b-dropdown-item>
              </b-col>
            </b-row>
            <div class="text-center bg-light py-3 w-100">
              <a href="#" class="fw-semi-bold" text="_blank" @click="viewProducts()">
                View Products
                <i class="fa fa-angle-right ml-2"></i>
              </a>
            </div>
          </b-dropdown>
        </header>
      </div>
    </b-nav>
    <b-nav class="head-pl-0" style="padding-left: 9px">
      <b-nav-item>
        <a class="d-md-down-none" href="#" @click="toggleSidebarMethod" id="barsTooltip">
          <i class="la la-bars la-lg mt-1" />
        </a>

        <a class="fs-lg d-lg-none" href="#" @click="switchSidebarMethod">
          <span class="rounded bg-gray text-white d-md-none">
            <i class="la la-bars" />
          </span>
          <i class="la la-bars d-sm-down-none" />
        </a>
      </b-nav-item>
    </b-nav>

    <b-nav>
      <b-form
        class="d-sm-down-none ml-5"
        inline
        @submit.prevent="onSubmit()"
        v-if="$route.meta.search"
      >
        <b-form-group>
          <b-input-group class="input-group-no-border">
            <div
              class="input-group-addon d-flex align-items-center"
              style="border-radius: 15px 0px 0px 15px"
            >
              <i
                class="la la-search la-lg px-2 text-muted"
                v-if="
                  $route.meta.title != 'Banking' &&
                    $route.meta.title != 'Price Lists' &&
                    $route.meta.title != 'Product Bundles' &&
                    $route.meta.title != 'Sales Returns' &&
                    $route.meta.page != 'reports'
                "
                v-b-modal.AdvanceSearch
                style="cursor: pointer"
                v-b-tooltip
                title="Advance Search"
              />
            </div>
            <b-input
              id="search-input"
              name="search"
              placeholder="Search"
              v-model.trim="search"
              :style="
                $route.meta.title != 'Banking' &&
                $route.meta.title != 'Price Lists' &&
                $route.meta.title != 'Product Bundles' &&
                $route.meta.title != 'Sales Returns' &&
                $route.meta.page != 'shipment' &&
                $route.meta.title != 'Sales Returns' &&
                $route.meta.page != 'reports'
                  ? 'border-radius:0px 15px 15px 0px !important'
                  : 'border-radius:15px 15px 15px 15px !important;padding-left:15px !important'
              "
            />
            <input type="hidden" name="page" :value="$route.query.page" />
            <input type="hidden" name="show" :value="$route.query.show" />
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-nav>

    <b-nav class="ml-auto tab-nav">
      <b-nav-item no-caret right>
        {{ comp_name }}
      </b-nav-item>
      <b-nav-item class>
        <router-link
          :to="{
            name: RoutePermission(false, '', 'invoice', 'settings', 'generalpreferences')
              ? 'UserTheme'
              : 'Currency',
          }"
        >
          <i class="la la-cog" style="font-size: 18px" />
        </router-link>
      </b-nav-item>
    </b-nav>

    <b-nav class="ml-right head-pr-0" style="padding-right: 9px">
      <b-nav-dropdown class="settingsDropdown" no-caret right menu-class="pr-0">
        <template slot="button-content">
          <i class="la la-user" style="margin-right: -6px" />
        </template>
        <div id="flyout">
          <div
            class="header"
            style="
              text-align: center;
              background-color: rgb(248, 248, 248);
              border-bottom: 1px solid #e5e5e5;
            "
          >
            <span class="fa fa-user-circle-o pb-1 px-7 mt-4 mb-2" style="font-size: 30px" />

            <h5>{{ user_name + " [" + role_name + "]" }}</h5>

            <a @click="logout" style="background: transparent; border: none; outline: none">
              <span class="glyphicon glyphicon-off pb-1 px-2" /> Log Out
            </a>
            <b-row class="mt-5">
              <b-col class="text-left">
                <h5 class="text-muted pl-2">My Organization</h5>
              </b-col>
              <b-col class="text-right">
                <a :href="admin_url" target="_blank">
                  <h5 class="text-link pr-3"><i class="la la-cog px-2" />Manage</h5>
                </a>
              </b-col>
            </b-row>
          </div>

          <b-row class="mt-3 pb-5 pl-2">
            <b-col class="md-9">
              <table class="org-details" style="width: 100%">
                <tbody>
                  <tr v-for="item in $AppDetails.customer_org_lists" :key="item.org_id">
                    <td
                      class="fw-semi-bold pb-0 pt-0"
                      @click="
                        $AppDetails.organization.org_id != item.org_id
                          ? getSwitchOrg(item.org_id)
                          : ''
                      "
                      style="cursor: pointer"
                    >
                      {{ item.comp_name }}
                      <br />
                      <span class="text-muted">{{ item.org_mail }}</span>
                      <br />
                      <span
                        class="text-muted text-success"
                        v-if="$AppDetails.organization.org_id == item.org_id"
                      >
                        <i class="fa fa-check-circle-o mr-2"></i>
                        Active
                      </span>
                      <hr />
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </div>
      </b-nav-dropdown>
    </b-nav>
    <ShortcutkeyModal />
    <GlobalAdvanceSearchModal
      v-if="$route.meta.search"
      :module="
        $route.meta.title == 'Quotations'
          ? 'Sales'
          : $route.meta.title != 'Payments Received' && $route.meta.title != 'Custom Filter'
          ? $route.meta.title.substring(0, $route.meta.title.length - 1)
          : $route.meta.title
      "
    />
    <back-to-top :visibility-height="300" :back-position="50" transition-name="fade" />
  </b-navbar>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import isScreen from "@/core/screenHelper";
import { removeToken } from "@/utils/auth";
import ShortcutkeyModal from "@/components/Modal/ShortcutkeyModal";
import BackToTop from "@/components/BackToTop/index";
export default {
  name: "Header",
  components: {
    ShortcutkeyModal,
    BackToTop,
  },
  data() {
    return {
      admin_url: process.env.VUE_APP_LOGOUT_URL,
      app_display_name: "",
      user_name: "",
      comp_name: "",
      app_urls: [],
      search: this.$route.query.search,
      status: this.$route.query.status,
    };
  },
  computed: {
    ...mapState("layout", {
      sidebarClose: (state) => state.sidebarClose,
      sidebarStatic: (state) => state.sidebarStatic,
    }),
    ...mapGetters(["role_name"]),
  },
  methods: {
    getSwitchOrg($id) {
      var data = {
        org_id: $id,
      };
      this.$store.dispatch("session/switchSession", data);
    },
    onSubmit() {
      this.$router.push({
        name: this.$route.name,
        query: {
          page: 1,
          show: this.$route.params.show,
          search: this.search,
          status: "",
          sort: this.$route.params.sort,
          label: this.$route.params.label,
          from_date: this.$route.params.from_date || this.$route.query.from_date,
          to_date: this.$route.params.to_date || this.$route.query.to_date,
          report_date: this.$route.query.report_date,
          name: this.$route.query.name,
          sales_tags: this.$route.query.sales_tags,
          filter_by: this.$route.query.filter_by,
          sales_person: this.$route.query.sales_person,
          id: this.$route.query.id,
        },
      });
      this.search = "";
    },
    getImgUrl(app_image) {
      var images = require.context("./../../assets/people/", false, /\.png$/);
      return images("./" + app_image + ".png");
    },
    ...mapActions("layout", ["toggleSidebar", "switchSidebar", "changeSidebarActive"]),
    switchSidebarMethod() {
      if (!this.sidebarClose) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      } else {
        this.switchSidebar(false);
        const paths = this.$route.fullPath.split("/");
        paths.pop();
        this.changeSidebarActive(paths.join("/"));
      }
    },
    toggleSidebarMethod() {
      if (this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      } else {
        this.toggleSidebar();
        const paths = this.$route.fullPath.split("/");
        paths.pop();
        this.changeSidebarActive(paths.join("/"));
      }
    },

    logout() {
      removeToken();
      window.location.href =
        process.env.VUE_APP_ORG_LOGOUT_URL +
        "?url=" +
        window.location.protocol +
        "//" +
        window.location.hostname;
    },
    viewProducts() {
      window.open(process.env.VUE_APP_LOGOUT_URL, "_blank");
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    },
  },
  created() {
    this.app_urls = this.$AppDetails.app_urls;
    this.user_name = this.$AppDetails.user_name;
    this.app_display_name =
      typeof this.$AppDetails.organization.org_display_name != "undefined" &&
      this.$AppDetails.organization.org_display_name != "" &&
      this.$AppDetails.organization.org_display_name != null
        ? this.$AppDetails.organization.org_display_name
        : "Shanki Invoice";
    this.comp_name = this.$AppDetails.organization.comp_name;
  },
};
</script>
<style lang="scss">
.logo .btn {
  width: 200px;
  text-decoration-line: none !important;
  background-image: unset !important;
}
.logo .dropdown-menu.show {
  width: 430px;
}
.sidebarClose .head-hide {
  display: none;
}
// .sidebarClose .logo .dropdown-menu.show {
//   display: none !important;
// }
.sidebarClose.sidebarStatic .dropdown-menu.show {
  display: block !important;
}
.sidebarStatic .head-hide {
  display: block !important;
}
.sidebarStatic .head-unhide {
  display: none !important;
}
// .logo .dropdown-menu.show {
//   transform: none !important;
//   top: 100% !important;
// }
html,
body {
  height: 100%;
}
.navbar .input-group {
  width: 280px !important;
}
</style>

<style src="./Header.scss" lang="scss" scoped />
